import type { ReactNode } from 'react';
import { Box, Divider, Grid, Stack, Typography } from 'ui';

const InfoRow = ({ label, value }: { label: string; value: string | number }) => (
  <Box display="flex" flexDirection="column">
    <Typography variant="body2" fontWeight="bold" marginBottom={0.5}>
      {label}
    </Typography>
    <Typography variant="body2">{value}</Typography>
  </Box>
);

type DrawerSectionProps = {
  title: ReactNode;
  name: string;
  elements: { label: string; value: string | number }[];
  'data-testid'?: string;
};

export const DrawerSection = ({ title, elements, name, 'data-testid': dataTestId }: DrawerSectionProps) => {
  return (
    <>
      <Stack direction="column" gap={2} data-testid={dataTestId}>
        <Typography color="text.secondary">{title}</Typography>
        <Grid container>
          {elements.map((item, index) => (
            <Grid item xs={4} key={`${name}-${index}`}>
              <InfoRow label={item.label} value={item.value} />
            </Grid>
          ))}
        </Grid>
      </Stack>
      <Divider />
    </>
  );
};
